import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HTTP_OPTIONS, URL_SERVICIOS } from '../shared/config/config';
import { OtpValidate, OtpRequest, OtpVerify, OtpValidated, Petition, messageValidation, } from '../interfaces/interfaces.index';
const URL = `${URL_SERVICIOS}external`;

@Injectable({
  providedIn: 'root'
})
export class ExternalService {

  constructor(private http: HttpClient) {}

  requestOtp = (data: OtpRequest) => this.http.post<OtpValidate>(`${URL}/requestOtp`, JSON.stringify(data), HTTP_OPTIONS).toPromise();
  
  validateOtp = (data: OtpVerify) => this.http.post<OtpValidated>(`${URL}/validateOtp`, JSON.stringify(data), HTTP_OPTIONS);
  
  validateRotuine = (data: Petition) => this.http.post<messageValidation>(`${URL}/requestRotuine`, JSON.stringify({ petitionId: data.id }), HTTP_OPTIONS);

  runRoutine = (routineNumber: string, petitionId: number, data: any) => this.http.post<any>(`${URL}/Routines/${routineNumber}?petitionId=${petitionId}`, data, HTTP_OPTIONS);

  getParamB = (data: string) => this.http.get<any>(`${URL}/param/${data}/b`);

  getParamI = (data: string) => this.http.get<any>(`${URL}/param/${data}/i`);

  getParamS = (data: string) => this.http.get<any>(`${URL}/param/${data}/s`);
}
